import { Router, useRouter } from 'vue-router';
import { ProgressLoader } from './useProgressLoader';

export const useRouterProgressLoader = (loader: ProgressLoader, inputRouter?: Router) => {
	const router = inputRouter || useRouter();

	let routerLoadingSegmentId: number;
	let routerLoadingTimeout: ReturnType<typeof setTimeout> | null = null;

	router.beforeEach(() => {
		if (routerLoadingSegmentId) {
			loader.finish(routerLoadingSegmentId);
		}

		routerLoadingTimeout = setTimeout(() => {
			routerLoadingSegmentId = loader.start();
			routerLoadingTimeout = null;
		}, 50);
	});

	router.afterEach(() => {
		if (routerLoadingTimeout) {
			clearTimeout(routerLoadingTimeout);
		}

		if (routerLoadingSegmentId) {
			loader.finish(routerLoadingSegmentId);
		}
	});
};
